import { useLocation, useSearchParams } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { downloadFile, getAllQueryParams, getObjectName, getQueryFilter, setQueryParams } from 'utils/utils'
import { INITIAL_DATA_FILTER } from 'configs/product/configTableGiftList'
import { GiftList } from 'components/product/gift-list/GiftList'
import { useFetch } from 'services/useFetch'
import { API_GIFT } from 'services/apiGift'
import moment from 'moment/moment'
import { Alert } from 'avo-ui'

const INIT_FILTER = {
    status: [],
}

const INIT_STATUS = [
    {
        label: 'Publish',
        value: 'publish',
    },
    {
        label: 'Draft',
        value: 'draft',
    },
    {
        label: 'Delete',
        value: 'delete',
    },
]

export const GiftListContainer = () => {
    const location = useLocation()
    const [searchParams, setSearchParams] = useSearchParams()
    const [queryFilter, setQueryFilter] = useState({})
    const query = searchParams.size > 0 ? getAllQueryParams(searchParams) : INITIAL_DATA_FILTER
    const [selectedIds, setSelectedIds] = useState([])
    const [selectedStatus, setSelectedStatus] = useState(INIT_STATUS[0])
    const [isResetSelectedItem, setIsResetSelectedItem] = useState(false)
    const [modalMessage, setModalMessage] = useState('')
    const { fetching: getDraftList, data: draftList, isLoading } = useFetch(API_GIFT.LIST)
    const { fetching: exportGift, isLoading: isExporting } = useFetch(API_GIFT.EXPORT)
    const { fetching: bulkAction, isLoading: isBulkAction } = useFetch(API_GIFT.BULK_ACTION)
    const [modal, setModal] = useState({
        filter: false,
        export: false,
        confirm: false,
        delete: false,
    })

    useEffect(() => {
        const currentQuery = { ...query }
        const newQueryFilter = { ...INIT_FILTER }
        Object.entries(currentQuery).forEach(([key, item]) => {
            if (key === 'status') {
                const valueOfQuery = item?.split(',')
                newQueryFilter[key] = valueOfQuery
                currentQuery[key] = valueOfQuery
            }
        })
        setQueryFilter(newQueryFilter)
        fetchGiftList(currentQuery)
    }, [location?.search])

    const onChangeQuery = (queryParams) => {
        const isReset = getObjectName(queryParams)?.some((item) => ['search', 'status'].includes(item))
        if (isReset) setIsResetSelectedItem(!isResetSelectedItem)
        const params = setQueryParams({ ...query, ...queryParams })
        setSearchParams(params, { replace: true })
    }

    const fetchGiftList = (item = { ...query, ...queryFilter }) => {
        getDraftList(item)
    }

    const setShowModal = (item) => {
        setModal({ ...modal, ...item })
    }

    const setShowAlert = (message, itemModal) => {
        setShowModal(itemModal)
        return Alert({
            icon: 'success',
            title: 'Success',
            message,
        })
    }

    const onSelectSort = (value) => {
        const splitSort = value?.split('-')
        onChangeQuery({ order_by: splitSort[0], order_type: splitSort[1] })
    }

    const onFilter = (filter) => {
        const queryFilter = getQueryFilter(filter)
        onChangeQuery({ ...queryFilter, page: 1 })
    }

    const onExport = () => {
        const combineObj = { ...query, ...queryFilter }
        const { page, limit, ...dataFilterRest } = combineObj
        const payload = { ...dataFilterRest, gift_ids: selectedIds }
        exportGift(payload, '', {}, 'blob').then((response) => {
            downloadFile(null, response, `Gift-Export-${moment().format('DD-MM-YYYY')}.xlsx`)
            setShowAlert('Gift Exported', { export: false })
        })
    }

    const onSelectItemHandler = (item) => {
        const ids = item?.map((i) => i?.id)
        setSelectedIds(ids)
    }

    const onChangeStatus = (item) => {
        setSelectedStatus(item?.value)
    }

    const onApply = () => {
        if (selectedStatus?.value === INIT_STATUS[2].value) {
            setModalMessage('Are You Sure to Delete Gift?')
            setShowModal({ delete: true })
        } else {
            setModalMessage(`Are You Sure to Change Product Gift to ${selectedStatus?.label}?`)
            setShowModal({ confirm: true })
        }
    }

    const onConfirm = () => {
        const payload = {
            gift_ids: selectedIds,
            action: selectedStatus?.value,
        }
        bulkAction(payload)
            .then(() => {
                const itemModal = selectedStatus?.value === 'delete' ? { delete: false } : { confirm: false }
                const msg = selectedStatus?.value === 'delete' ? 'Delete Data Successfully' : 'Product Status Updated'
                selectedStatus?.value === 'delete' && setIsResetSelectedItem(!isResetSelectedItem)
                setShowAlert(msg, itemModal)
                fetchGiftList()
            })
            .catch((error) => {
                return Alert({
                    icon: 'error',
                    title: error?.message,
                    message: 'Periksa kembali data gift yang masih belum dilengkapi',
                })
            })
    }

    const props = {
        dataList: draftList?.data,
        modal,
        setShowModal,
        onSelectSort,
        query,
        onChangeQuery,
        queryFilter,
        onFilter,
        selectedIds,
        statusOptions: INIT_STATUS,
        selectedStatus,
        onChangeStatus,
        onApply,
        modalMessage,
        onConfirm,
        onExport,
        onSelectItemHandler,
        isLoading,
        isExporting,
        isBulkAction,
        isResetSelectedItem,
    }

    return <GiftList {...props} />
}
